import { GET_PERMISSIONS_START } from '../../types';

export const permissions = (payload) => ({
  type: GET_PERMISSIONS_START,
  payload,
});
